/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type AgeEnum = (typeof AgeEnum)[keyof typeof AgeEnum];

export const AgeEnum = {
  adolescent: 'adolescent',
  adult: 'adult',
  elderly: 'elderly',
} as const;
